import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

export default function LoadingMask({ loading, withSpinner }) {
  return (
    <div className={classNames(
      'pg-pageLoadingMask',
      {
        'pg-pageLoadingMask--visible': loading,
        'pg-pageLoadingMask--withSpinner': withSpinner,
      },
    )}
    />
  );
}

LoadingMask.propTypes = {
  loading: PropTypes.bool,
  withSpinner: PropTypes.bool,
};
